import { createStitches, keyframes } from '@stitches/core';
import { c as isMobile } from '../../../../dist/utils-1cd6e65a.esm.js';
import { _ as _defineProperty } from '../../../../dist/defineProperty-e24c82ea.esm.js';
import { aspectRatios } from '@livepeer/core/media';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';

var accent = '#00a55f';
var muted = '#B7B7B7';
var icon = 'rgba(255,255,255,1)';
var theme = {
  borderStyles: {
    containerBorderStyle: 'solid'
  },
  borderWidths: {
    containerBorderWidth: 0,
    loadingWidth: '3px'
  },
  colors: {
    accent: accent,
    background: '#000000',
    containerBorderColor: 'transparent',
    icon: icon,
    iconHover: 'rgba(255,255,255,0.8)',
    liveIndicator: '#e5484d',
    loading: accent,
    progressLeft: accent,
    progressMiddle: accent,
    progressRight: accent,
    progressThumb: icon,
    volumeLeft: accent,
    volumeMiddle: accent,
    volumeRight: accent,
    volumeThumb: icon,
    errorText: muted
  },
  fonts: {
    display: 'ui-sans-serif'
  },
  fontSizes: {
    timeFontSize: '1.0rem',
    timeFontSizeMd: '0.95rem',
    timeFontSizeSm: '0.85rem',
    titleFontSize: '1.1rem',
    titleFontSizeMd: '1rem',
    titleFontSizeSm: '0.9rem',
    errorTitleFontSize: '2.5rem',
    errorTitleFontSizeMd: '2.0rem',
    errorTitleFontSizeSm: '1.3rem',
    errorTextFontSize: '0.95rem',
    errorTextFontSizeMd: '0.85rem',
    errorTextFontSizeSm: '0.75rem'
  },
  fontWeights: {
    titleFontWeight: '400',
    errorTitleFontWeight: '700'
  },
  sizes: {
    iconButtonSize: '42px',
    iconButtonSizeSm: '36px',
    liveIndicatorSize: '5px',
    loading: '64px',
    thumb: '10px',
    thumbActive: '12px',
    trackActive: '5px',
    trackContainerHeight: '15px',
    trackContainerHeightSm: '20px',
    trackInactive: '3px'
  },
  space: {
    controlsBottomMarginX: '10px',
    controlsBottomMarginY: '5px',
    controlsTopMarginX: '15px',
    controlsTopMarginY: '10px',
    timeMarginX: '8px'
  },
  radii: {
    containerBorderRadius: '0px',
    slider: '3px'
  }
};
var _createStitches = createStitches({
    media: {
      sm: '(min-width: 640px)',
      md: '(min-width: 768px)',
      lg: '(min-width: 1024px)'
    },
    theme: theme
  }),
  css = _createStitches.css,
  createTheme = _createStitches.createTheme,
  defaultTheme = _createStitches.theme,
  getCssText = _createStitches.getCssText;

var scaleUp = keyframes({
  '0%': {
    transform: 'scale(1)'
  },
  '100%': {
    transform: 'scale(1.1)'
  }
});
var iconButton = css('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  outline: 'inherit',
  padding: 0,
  height: '$iconButtonSizeSm',
  width: '$iconButtonSizeSm',
  minHeight: '$iconButtonSizeSm',
  minWidth: '$iconButtonSizeSm',
  '@lg': {
    height: '$iconButtonSize',
    width: '$iconButtonSize',
    minHeight: '$iconButtonSize',
    minWidth: '$iconButtonSize'
  },
  color: '$icon',
  '&:hover': {
    color: '$iconHover',
    animation: !isMobile() ? "".concat(scaleUp, " 200ms") : undefined
  }
});

var _aspectRatio;
var aspectRatioContainer = css('div', {
  variants: {
    aspectRatio: (_aspectRatio = {}, _defineProperty(_aspectRatio, aspectRatios[0].key, _defineProperty({
      aspectRatio: aspectRatios[0].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[0].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[0].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[1].key, _defineProperty({
      aspectRatio: aspectRatios[1].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[1].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[1].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[2].key, _defineProperty({
      aspectRatio: aspectRatios[2].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[2].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[2].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[3].key, _defineProperty({
      aspectRatio: aspectRatios[3].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[3].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[3].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _defineProperty(_aspectRatio, aspectRatios[4].key, _defineProperty({
      aspectRatio: aspectRatios[4].value
    }, "@supports not (aspect-ratio: ".concat(aspectRatios[4].value, ")"), {
      '&:before': {
        float: 'left',
        paddingTop: "calc(".concat(aspectRatios[4].value, ")%"),
        content: ''
      },
      '&:after': {
        display: 'block',
        content: '',
        clear: 'both'
      }
    })), _aspectRatio)
  }
});
var container$3 = css(aspectRatioContainer, {
  fontFamily: '$display, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
  backgroundColor: '$background',
  overflow: 'hidden',
  maxWidth: '100%',
  maxHeight: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  svg: {
    pointerEvents: 'none'
  },
  variants: {
    size: {
      fullscreen: {
        // for iOS rendering custom controls
        zIndex: 2147483647
      },
      default: {
        boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
        borderStyle: '$containerBorderStyle',
        borderColor: '$containerBorderColor',
        borderRadius: '$containerBorderRadius',
        borderWidth: '$containerBorderWidth',
        zIndex: 1
      }
    }
  },
  defaultVariants: {
    size: 'default'
  }
});

var text = css('span', {
  color: '$icon',
  userSelect: 'none'
});

var errorBackground = css('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '220px',
  marginTop: '1rem',
  '@md': {
    maxWidth: '340px'
  },
  maxHeight: '100%'
});
var errorTitle = css(text, {
  fontWeight: '$errorTitleFontWeight',
  margin: '0.5rem 0 0.5rem 0',
  fontSize: '$errorTitleFontSizeSm',
  '@md': {
    fontSize: '$errorTitleFontSizeMd',
    margin: '2rem 0 0.5rem 0'
  },
  '@lg': {
    fontSize: '$errorTitleFontSize'
  }
});
var errorText = css(text, {
  fontWeight: '$titleFontWeight',
  color: '$errorText',
  textAlign: 'center',
  width: '90%',
  fontSize: '$errorTextFontSizeSm',
  marginBottom: '1rem',
  '@md': {
    fontSize: '$errorTextFontSizeMd'
  },
  '@lg': {
    fontSize: '$errorTextFontSize'
  }
});
var error = {
  background: errorBackground,
  title: errorTitle,
  text: errorText
};

var rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
var loading = css('div', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  maxWidth: '100%',
  maxHeight: '100%',
  '&:after': {
    content: ' ',
    display: 'block',
    width: '$loading',
    height: '$loading',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '50%',
    borderWidth: '$loadingWidth',
    borderStyle: 'solid',
    borderColor: '$loading transparent $loading transparent',
    animation: "".concat(rotate, " 1.4s ease-in-out infinite")
  }
});

var hidden = keyframes({
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
var shown = keyframes({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
var sharedContainer = css('div', {
  variants: {
    display: {
      shown: {
        opacity: 1,
        animation: !isMobile() ? "".concat(shown, " 0.2s") : undefined
      },
      hidden: {
        opacity: 0,
        animation: !isMobile() ? "".concat(hidden, " 0.2s") : undefined
      }
    }
  },
  defaultVariants: {
    display: 'shown'
  }
});
var background = css(sharedContainer, {
  position: 'absolute',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  height: '100%'
});
var gradient = css(sharedContainer, {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 233,
  marginBottom: -1,
  maxWidth: '100%',
  maxHeight: '100%',
  overflow: 'hidden',
  backgroundImage: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADpCAYAAADlAl1mAAAAAXNSR0IArs4c6QAAAexJREFUOE9V0ftrzXEcx/H3x+43l9lmGGaz65ld2YUZG2YYKUlJUpKSpNZSkpSkJClJSVKSkj9Sj8/3nJ12fnie5/v9en/en+/3nIjik6rfNOU6YwfJqNGp0ctWGylSLavTqzNe72S9YYgGaYOysYJodKxJ2uSeZseaC4uUWpQt0lbWWlhEtFnVZv1O5RbSLkHGbifKiBR7XJnR7kS7dG+BSNlSh7TDvZ02d5rL6DLXxfYZriCiW69bbz+rIKUDyoyDW+hxB0RPpJQOCTIOb8cRZUavB+r1QCyOVpD6WJ97s/Wb67f5GINsMaA3YG6QDbIh7zZUWEQaNjesHHHRiB7EqLlRx0qsZKQkHdMb0zturopx5bhgwqoJJaRJNmnBlGBKj8W0YNq+GTbjFzrBqjipzJh1bNYxFnNsjs1bMF9YpFhgC3qnCkQkiNMMYlGwqDzDyoiIJc+35O85a66MFHFOmbHsjmVnM1Y884rgvLKClC4oIS5ux6pg1ZZLgow1v9pa2SIus4wrBVKkbFedhVhn67Zku2bBdcENr3CT3ZLe9oJ32F12T3DfCz7QewiP9B7b8kT5VPmMbVi6yZ7DCwtemnvFXrvoDXtr7p3gPXxQfhR8suqz8gv7Kv3mZb5Lf+j91PvFfsMf+Av//gMAXDGpZ05jKQAAAABJRU5ErkJggg==")'
});
var topContainer = css(sharedContainer, {
  top: 0,
  marginTop: '$controlsTopMarginY',
  marginBottom: '$controlsTopMarginY',
  marginLeft: '$controlsTopMarginX',
  marginRight: '$controlsTopMarginX',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'absolute',
  left: 0,
  right: 0
});
var bottomContainer = css(sharedContainer, {
  justifyContent: 'center',
  bottom: 0,
  marginTop: '$controlsBottomMarginY',
  marginBottom: '$controlsBottomMarginY',
  marginLeft: '$controlsBottomMarginX',
  marginRight: '$controlsBottomMarginX',
  display: 'inline-flex',
  alignItems: 'center',
  position: 'absolute',
  flexDirection: 'column',
  left: 0,
  right: 0
});
var spaceBetweenContainer = css('div', {
  width: '100%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});
var right$1 = css(spaceBetweenContainer, {
  width: 'auto'
});
var left$1 = css(spaceBetweenContainer, {
  width: 'auto'
});
var loadingText = css(sharedContainer, {
  top: 0,
  userSelect: 'none',
  color: '$icon',
  marginTop: '$controlsTopMarginY',
  marginBottom: '$controlsTopMarginY',
  marginLeft: '$controlsTopMarginX',
  marginRight: '$controlsTopMarginX',
  display: 'inline-flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  position: 'absolute',
  fontSize: '$timeFontSizeSm',
  '@md': {
    fontSize: '$timeFontSizeMd'
  },
  '@lg': {
    fontSize: '$timeFontSize'
  },
  left: 0,
  right: 0,
  bottom: 0
});
var controlsContainer = {
  background: background,
  gradient: gradient,
  loading: loading,
  loadingText: loadingText,
  error: error,
  top: {
    container: topContainer
  },
  bottom: {
    container: bottomContainer,
    middle: {
      container: spaceBetweenContainer
    },
    lower: {
      container: spaceBetweenContainer,
      left: left$1,
      right: right$1
    }
  }
};

var poster = css('img', {
  maxWidth: '100%',
  width: '100%',
  maxHeight: '100%',
  height: '100%',
  pointerEvents: 'none',
  userSelect: 'none',
  objectPosition: 'center',
  objectFit: 'cover',
  variants: {
    size: {
      fullscreen: {
        width: '100% !important',
        height: '100% !important'
      },
      default: {}
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
var video = css('video', {
  width: '100% !important',
  height: '100% !important',
  objectPosition: 'center',
  variants: {
    size: {
      fullscreen: {
        objectFit: 'contain',
        '&::-webkit-media-overlay-enclosure': {
          display: 'none !important'
        },
        '&::-webkit-media-controls-enclosure': {
          display: 'none !important'
        }
      },
      contain: {
        objectFit: 'contain'
      },
      cover: {
        objectFit: 'cover'
      }
    }
  },
  defaultVariants: {
    size: 'cover'
  }
});
var audio = css('audio', video);
var media = {
  audio: audio,
  poster: poster,
  video: video
};

var expand = keyframes({
  '0%': {
    height: '$trackInactive'
  },
  '100%': {
    height: '$trackActive'
  }
});
var contract = keyframes({
  '0%': {
    height: '$trackActive'
  },
  '100%': {
    height: '$trackInactive'
  }
});
var container$2 = css('div', {
  minHeight: '$trackContainerHeightSm',
  '@lg': {
    minHeight: '$trackContainerHeight'
  },
  '@media (hover: none)': {
    minHeight: '$trackContainerHeightSm'
  },
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  minWidth: 80,
  touchAction: 'none',
  cursor: 'pointer',
  height: '100%',
  width: '100%'
});
var sharedTrack = css('div', {
  variants: {
    size: {
      default: {
        height: '$trackInactive',
        animation: "".concat(contract, " 0.1s")
      },
      active: {
        height: '$trackActive',
        animation: "".concat(expand, " 0.1s")
      }
    },
    rounded: {
      full: {
        borderRadius: '$slider'
      },
      left: {
        borderTopLeftRadius: '$slider',
        borderBottomLeftRadius: '$slider'
      },
      right: {
        borderTopRightRadius: '$slider',
        borderBottomRightRadius: '$slider'
      },
      none: {}
    }
  },
  defaultVariants: {
    size: 'default',
    rounded: 'none'
  }
});
var left = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.95
});
var middle = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.55
});
var right = css(sharedTrack, {
  backgroundColor: '$accent',
  opacity: 0.2
});
var thumb = css('div', {
  variants: {
    size: {
      default: {
        width: '$thumb',
        height: '$thumb'
      },
      active: {
        width: '$thumbActive',
        height: '$thumbActive'
      }
    }
  },
  defaultVariants: {
    size: 'default'
  },
  backgroundColor: '$icon',
  borderRadius: '100%'
});
var slider = {
  container: container$2,
  thumb: thumb,
  track: {
    left: left,
    middle: middle,
    right: right
  }
};

var pulse = keyframes({
  '0%, 100%': {
    opacity: 1
  },
  '50%': {
    opacity: 0.5
  }
});
var container$1 = css('div', {
  marginLeft: '$timeMarginX',
  marginRight: '$timeMarginX',
  display: 'flex',
  alignItems: 'center'
});
var liveIndicator = css('div', {
  backgroundColor: '$liveIndicator',
  borderRadius: '100%',
  width: '$liveIndicatorSize',
  height: '$liveIndicatorSize',
  animation: "".concat(pulse, " 2s cubic-bezier(0.4, 0, 0.6, 1) infinite")
});
var timeText = css(text, {
  marginLeft: '$timeMarginX',
  marginRight: '$timeMarginX',
  fontVariant: 'tabular-nums',
  fontSize: '$timeFontSizeSm',
  '@md': {
    fontSize: '$timeFontSizeMd'
  },
  '@lg': {
    fontSize: '$timeFontSize'
  }
});
var time = {
  container: container$1,
  text: timeText,
  liveIndicator: liveIndicator
};

var title = css(text, {
  fontWeight: '$titleFontWeight',
  fontSize: '$titleFontSizeSm',
  '@md': {
    fontSize: '$titleFontSizeMd'
  },
  '@lg': {
    fontSize: '$titleFontSize'
  }
});

var container = css('div', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var volume = {
  container: container
};

var styling = {
  container: container$3,
  controlsContainer: controlsContainer,
  iconButton: iconButton,
  media: media,
  slider: slider,
  time: time,
  title: title,
  volume: volume
};

export { createTheme, defaultTheme, getCssText, styling };
